import { useMemo } from 'react';
import { GridColDef } from '@mui/x-data-grid-premium';
import dayjs from 'dayjs';
import { AudioFileHistory } from '@aviation/cabinapp-cabincast-sdk';
import { useFetch } from '../../../hooks/useFetch';
import ReadOnlyGridDialog from './ReadOnlyGridDialog';

const formatDateTime = (value?: string) => {
    if (!value) return '';
    const date = dayjs(value);
    return date.isValid() ? date.toDate().toLocaleString() : value;
};

const columns: GridColDef[] = [
    { field: 'ModifiedOn', headerName: 'Modified on', width: 180, valueFormatter: (params) => formatDateTime(params.value) },
    { field: 'ModifiedBy', headerName: 'Modified by', minWidth: 200 },
    { field: 'Description', headerName: 'Description', minWidth: 300, flex: 1 },
];

export interface IAudioFileHistoryDialogProps {
    open: boolean;
    audioFileId: string;
    onClose: () => void;
}

function AudioFileHistoryDialog({ open, audioFileId, onClose }: IAudioFileHistoryDialogProps) {
    // An empty URL makes useFetch skip the request until the dialog is opened.
    const { status, data } = useFetch<AudioFileHistory[]>(
        open ? `/api/audiofiles/${audioFileId}/history` : '',
        (response) => Array.isArray(response) ? response : (response?.Items ?? []),
        0, true);

    const rows = useMemo(() => (data ?? [])
        .map((h, index) => ({ ...h, id: `${h.ModifiedOn ?? ''}-${index}` }))
        .sort((a, b) => (b.ModifiedOn ?? '').localeCompare(a.ModifiedOn ?? '')), [data]);

    return <ReadOnlyGridDialog open={open} title='Change History' rows={rows} columns={columns} status={status} onClose={onClose} />;
}

export default AudioFileHistoryDialog;
